export enum CardSource {
  GPay = 'GPay',
  ApplePay = 'APPLE_PAY'
}
